// FacebookContext.js - Context để quản lý Facebook auth toàn cục
/* eslint-disable @typescript-eslint/naming-convention */
import { createContext } from 'react';
import useFacebook from '../hooks/useFacebook';
// import FacebookService from './services/facebookService';
// import apiService from './services/apiService';

export const FacebookContext = createContext(null);

export const FacebookProvider = ({ children }) => {
  const {
    // State
    isLoading,
    isLoggedIn,
    userData,
    code,
    error,

    // Methods
    login,
    logout,
    // refreshStatus,
  } = useFacebook();

  const value = {
    isLoading,
    isLoggedIn,
    userData,
    code,
    error,
    login,
    logout,
    // refreshStatus,
  };

  return (
    <FacebookContext.Provider value={value}>
      {children}
    </FacebookContext.Provider>
  );
};
